import { Link as RouterLink } from "react-router-dom";
import { Box, Button, Container, Grid, Paper, Stack, Typography } from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";

interface Tier {
  name: string;
  price: string;
  period?: string;
  description: string;
  features: string[];
  ctaLabel: string;
  ctaHref: string;
  highlighted?: boolean;
}

const TIERS: Tier[] = [
  {
    name: "Starter",
    price: "₹0",
    description: "Get familiar with the platform.",
    features: ["Core learning content", "Open Interest analytics"],
     ctaLabel: "Start Free Trial",
    ctaHref: "/register",
    highlighted: true,
  },
  {
    name: "Professional",
    price: "₹999",
    period: "/mo",
    description: "For active investors and traders.",
    features: ["Full AI market scanner", "Algo strategy deployment"],
    ctaLabel: "Start Free Trial",
    ctaHref: "/register",
    highlighted: true,
  },
  {
    name: "Enterprise",
    price: "1999",
    description: "Complete features.",
    features: ["Open Interest Analytics", "Algo Strategy deployment", "Portfolio tracker"],
    ctaLabel: "Start Free Trial",
    ctaHref: "/register",
    highlighted: true,
  },
];

export function PricingSection() {
  return (
    <Box sx={{ py: { xs: 10, md: 14 }, bgcolor: "grey.50" }} id="pricing">
      <Container maxWidth="lg">
        <Box textAlign="center" maxWidth={560} mx="auto" mb={8}>
          <Typography variant="h4" fontWeight={800} mb={2}>
            Plans that grow with you
          </Typography>
          <Typography variant="body1" color="text.secondary">
            Start free. Upgrade whenever you're ready.
          </Typography>
        </Box>

        <Grid container spacing={3} justifyContent="center" alignItems="stretch">
          {TIERS.map((tier) => (
            <Grid item xs={12} sm={6} md={4} key={tier.name}>
              <Paper
                variant="outlined"
                sx={{
                  p: 4,
                  height: "100%",
                  borderRadius: 3,
                  display: "flex",
                  flexDirection: "column",
                  border: tier.highlighted ? "2px solid" : undefined,
                  borderColor: tier.highlighted ? "primary.main" : undefined,
                  boxShadow: tier.highlighted ? 6 : 0,
                }}
              >
                <Typography variant="h6" fontWeight={700}>
                  {tier.name}
                </Typography>
                <Typography variant="h3" fontWeight={800} mt={1}>
                  {tier.price}
                  {tier.period && (
                    <Typography component="span" variant="body1" color="text.secondary">
                      {tier.period}
                    </Typography>
                  )}
                </Typography>
                <Typography variant="body2" color="text.secondary" mt={1} mb={3}>
                  {tier.description}
                </Typography>

                <Stack spacing={1.25} mb={4} flexGrow={1}>
                  {tier.features.map((feature) => (
                    <Stack direction="row" spacing={1} alignItems="center" key={feature}>
                      <CheckCircleIcon fontSize="small" color="success" />
                      <Typography variant="body2">{feature}</Typography>
                    </Stack>
                  ))}
                </Stack>

                {tier.ctaHref.startsWith("mailto:") ? (
                  <Button
                    component="a"
                    href={tier.ctaHref}
                    variant={tier.highlighted ? "contained" : "outlined"}
                    size="large"
                    fullWidth
                  >
                    {tier.ctaLabel}
                  </Button>
                ) : (
                  <Button
                    component={RouterLink}
                    to={tier.ctaHref}
                    variant={tier.highlighted ? "contained" : "outlined"}
                    size="large"
                    fullWidth
                  >
                    {tier.ctaLabel}
                  </Button>
                )}
              </Paper>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
}

export default PricingSection;
